import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { ShopSelectionStore } from '../state/shop-selection.store';
import { ActiveCustomerService } from '../services/active-customer/active-customer.service';
import { DetailedCustomer } from '../../shared/models/customer.model';

export const customerResolver: ResolveFn<DetailedCustomer> = async route => {
  const customerId = Number(route.queryParamMap.get('customerId'));
  const selected = inject(ShopSelectionStore).snapshot.customer;
  if (selected?.id === customerId) return selected;

  const router = inject(Router);
  const activeCustomerService = inject(ActiveCustomerService);
  const customer = await activeCustomerService.activate(customerId);
  return customer ?? new RedirectCommand(router.parseUrl('/customer-select'));
};
